import { useCallback, useState } from 'react';
import { ApiError } from '@vanialabs/core-api';

import {
  updateTenant,
  updateTenantRepresentative,
} from '../api/tenants.api';

function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const detail = (error.body as { detail?: unknown } | undefined)?.detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
  }
  return 'خطا در به‌روزرسانی تننت. لطفاً دوباره تلاش کنید.';
}

export function useUpdateTenant() {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(
    id: string,
    tenant: { name: string; slug: string },
    representative: { mobile: string; password?: string },
    original: { name: string; slug: string; mobile: string },
  ) {
    setSubmitting(true);
    setError(null);
    try {
      if (tenant.name !== original.name || tenant.slug !== original.slug) {
        await updateTenant(id, tenant);
      }

      if (
        representative.mobile !== original.mobile ||
        representative.password
      ) {
        await updateTenantRepresentative(id, representative);
      }
    } catch (error) {
      setError(errorMessage(error));
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  const resetError = useCallback(() => {
    setError(null);
  }, []);

  return { submit, submitting, error, resetError };
}
